// extracted by mini-css-extract-plugin
export default {"grey200":"#eeeeee","tab":"Panel_tab__z6hfk","hidden":"Panel_hidden__fOI2N","icon":"Panel_icon__-ZonX"};